var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticStyle: { padding: "0px" }, attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "Subheader",
                {
                  attrs: { title: "Units", search: "Unit" },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.clickAddUnit()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v(_vm._s(_vm.$t("Button.AddUnit")) + "\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.allUnits,
                          pagination: _vm.pagination,
                          search: _vm.search,
                        },
                        on: {
                          "update:pagination": function ($event) {
                            _vm.pagination = $event
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function (props) {
                              return [
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.Name)),
                                ]),
                                _vm._v(" "),
                                _c("td", {
                                  staticClass: "text-xs-left",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm
                                        .getThisUnitGroupName(props.item.Groups)
                                        .toString()
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-right" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { dark: "", color: "warning" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickEditUnit(props.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { staticClass: "mr-1" }, [
                                          _vm._v("edit"),
                                        ]),
                                        _vm._v(
                                          _vm._s(_vm.$t("Button.Edit")) +
                                            "\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { dark: "", color: "delete" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickDeleteUnit(
                                              props.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { staticClass: "mr-1" }, [
                                          _vm._v("delete_forever"),
                                        ]),
                                        _vm._v(
                                          _vm._s(_vm.$t("Button.Remove")) +
                                            "\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("UnitDetailManage.addTitle")))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-layout",
                  { attrs: { wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: "Unit Name", required: "" },
                          model: {
                            value: _vm.unitData.unitName,
                            callback: function ($$v) {
                              _vm.$set(_vm.unitData, "unitName", $$v)
                            },
                            expression: "unitData.unitName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: "Unit Group",
                            items: _vm.allUnitGroups,
                            multiple: "",
                            hint: "Pick belong to Unit Group",
                            "persistent-hint": "",
                            "item-text": "Name",
                            "item-value": "Id",
                          },
                          model: {
                            value: _vm.unitData.belongToGroup,
                            callback: function ($$v) {
                              _vm.$set(_vm.unitData, "belongToGroup", $$v)
                            },
                            expression: "unitData.belongToGroup",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.clickSaveUnit()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        return _vm.closeDialog()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.addDialog,
          callback: function ($$v) {
            _vm.addDialog = $$v
          },
          expression: "addDialog",
        },
      }),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  _vm._s(
                    _vm.$t("UnitDetailManage.editTitle", {
                      msg: _vm.unitDetail.Name,
                    })
                  )
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-layout",
                  { attrs: { wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: "Unit Name", required: "" },
                          model: {
                            value: _vm.unitData.unitName,
                            callback: function ($$v) {
                              _vm.$set(_vm.unitData, "unitName", $$v)
                            },
                            expression: "unitData.unitName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: "Belong To Unit Group",
                            items: _vm.allUnitGroups,
                            multiple: "",
                            hint: "Pick belong to Unit Group",
                            "persistent-hint": "",
                            "item-text": "Name",
                            "item-value": "Id",
                          },
                          model: {
                            value: _vm.unitData.belongToGroup,
                            callback: function ($$v) {
                              _vm.$set(_vm.unitData, "belongToGroup", $$v)
                            },
                            expression: "unitData.belongToGroup",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.clickSaveEditUnit()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        return _vm.closeDialog()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.showEditUnit,
          callback: function ($$v) {
            _vm.showEditUnit = $$v
          },
          expression: "showEditUnit",
        },
      }),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.dialogMessage))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("UnitDetailManage.deleteMsg")))]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "delete", dark: "" },
                    on: {
                      click: function ($event) {
                        return _vm.agreeDeleteUnit()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("delete_forever")]),
                    _vm._v(_vm._s(_vm.$t("Button.Remove")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.dialog = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.dialog,
          callback: function ($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "left" },
              attrs: {
                "auto-height": "",
                color: _vm.snackbar.snackbarColor,
                timeout: null,
                top: "",
              },
              model: {
                value: _vm.snackbar.isSnackbarShow,
                callback: function ($$v) {
                  _vm.$set(_vm.snackbar, "isSnackbarShow", $$v)
                },
                expression: "snackbar.isSnackbarShow",
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.snackbar.snackbarMessage) + "\n      "
              ),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.hideSnackbar()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }